const acc = document.getElementsByClassName("accordion");
let ii;

for (ii = 0; ii < acc.length; ii++) {
  acc[ii].addEventListener("click", function() {
    this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight && panel.style.paddingBottom) {
      panel.style.maxHeight = null;
      panel.style.paddingBottom = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 30 + "px";
      panel.style.paddingBottom = "30px";
    }
  });
}

const addToCartBtn = document.querySelector("#AddToCart");
const findInstallerBtn = document.querySelector("#findInstaller");
const priceList = document.querySelector("[data-product-price-list]")
const priceListSticky = document.querySelector("[data-product-form-price-sticky]")
const priceTemplatePOA = () => {
  return `
  <span class="price price--large">
            <span class="visually-hidden">Sale price</span>
POA</span>
  `
}

window.onload = function() {
  var throttleTimer,
    mainAddToCartBtn = document.querySelector('#AddToCart:not(.sticky-button)'),
    priceListStickyContainer = document.querySelector('.product-form__sticky');

  function showStickyForm () {
    if (isInViewport(mainAddToCartBtn)) {
      priceListStickyContainer.classList.remove('showing')
    } else {
      priceListStickyContainer.classList.add('showing')
    }
  }

  function throttle (callback, time) {
    if (throttleTimer) return;
  
    throttleTimer = true;
    
    setTimeout(function() {
      if(typeof callback === 'function') callback();
      throttleTimer = false;
    }, time);
  }

  function isInViewport (el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }


  window.addEventListener('scroll', function () {
    throttle(
      showStickyForm(),
      500
    )
  })

  showStickyForm()
}

function CustomBtnTypeCheck(type){
  if(type=="POA"){
    addToCartBtn.style.display = "none"
    findInstallerBtn.style.display = "block"
    priceList.innerHTML = priceTemplatePOA();
    priceListSticky.innerHTML = priceTemplatePOA();
  }
  if(type==null){
    addToCartBtn.style.display = "block"
    findInstallerBtn.style.display = "none"
  }

}

const upsellBtn = document.querySelectorAll(".upsellAddToCart");

if(upsellBtn.length > 0){
  upsellBtn.forEach( (u, index) => {
    const variantId = u.getAttribute("data-id");
    const quantityElement = document.querySelectorAll('.quantity')
    u.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('index', index)
      const quantity = quantityElement[index].value
      ajaxAdd(variantId, parseInt(quantity));
    })
  })
}

const addOnCheckboxes = document.querySelectorAll(".add-on-upsell input");
addOnCheckboxes.forEach(addOnCheckbox => {
  addOnCheckbox.addEventListener('change', async function(){
    if(this.checked){
      ajaxAdd(this.value, 1);
    }
    // else{
    //   const cartData = await getCartData();
    //   for(let i = 0; i < cartData.items.length; i++) {
    //     if(cartData.items[i].id == this.value){
    //       deleteCartData(this.value);
    //       break;
    //     }
    //   }
    // }
  })
})

async function getCartData(){
  const response = await fetch(window.Shopify.routes.root + 'cart.js')
  
  return response.json()
}

// function deleteCartData(id){

//   let productData = {}
//   productData[id] = 0;

//   fetch(window.Shopify.routes.root + 'cart/update.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(productData)
//     }).then(response => {
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true
//       }));
//      return response.json();
//    });
// }

function ajaxAdd(variantId, quantity){
  let productData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };
 fetch(window.Shopify.routes.root + 'cart/add.js', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json'
   },
   body: JSON.stringify(productData)
 })
 .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    document.getElementById("mini-cart").open = true;
   return response.json();
 })
 .catch((error) => {
   console.error('Error:', error);
 });
}


const zoomBtn = document.querySelector('.product__zoom-button');
const productMedia = document.querySelector('product-media')
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes") {
       if(mutation.target.ariaExpanded === "true"){
          productMedia.classList.add("force-relative");
       }
       if(mutation.target.ariaExpanded === "false"){
         productMedia.classList.remove("force-relative");
       }
    }
  });
});

observer.observe(zoomBtn, {
  attributes: true
});


if (addToCartBtn) {
  const hiddenInput = document.getElementById('product-note-hidden');
  const externalTextarea = document.getElementById('product-note');

  if(externalTextarea) {
    externalTextarea.addEventListener('input', function() {
        hiddenInput.value = this.value;
    });
  }
}

document.querySelectorAll('.cu-product').forEach(row => {
  const minusButton = row.querySelector('.minus');
  const plusButton = row.querySelector('.plus');
  const inputField = row.querySelector('.quantity');
  console.log('minusButton', minusButton)

  minusButton.addEventListener('click', () => {
      let currentValue = parseInt(inputField.value, 10);
      if (currentValue > 1) {
          inputField.value = currentValue - 1;
      }
  });

  plusButton.addEventListener('click', () => {
      let currentValue = parseInt(inputField.value, 10);
      inputField.value = currentValue + 1;
  });

  // This is to ensure that users don't manually enter values less than 1
  inputField.addEventListener('change', () => {
      let currentValue = parseInt(inputField.value, 10);
      if (currentValue < 1 || isNaN(currentValue)) {
          inputField.value = 1;
      }
  });
});
